import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Tab from "@/components/containers/tabs/Tab";
import TabGroup from "@/components/containers/tabs/TabGroup";
import TabList from "@/components/containers/tabs/TabList";
import TabPanel from "@/components/containers/tabs/TabPanel";
import TabPanels from "@/components/containers/tabs/TabPanels";
import { type ChildRouteContext } from "@/root";
import {
  redirectIfModuleDisabled,
  throwIfHasNoPermission,
} from "@/utils/permissions";

import PerformanceObjectivesSetting from "../../../components/settings/PerformanceObjectivesSetting";
import PerformanceSettingsForm from "../../../components/settings/PerformanceSettingsForm";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/performance",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("performance", context.tenant.modules);

    throwIfHasNoPermission(
      context.user,
      "performance.performance-settings.view",
    );

    return {} satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  const { t } = useTranslation("core.admin");
  return (
    <TabGroup>
      <TabList>
        <Tab>{t("General", { ns: "core.shared" })}</Tab>
        <Tab>{t("Objectives")}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <PerformanceSettingsForm />
        </TabPanel>
        <TabPanel>
          <PerformanceObjectivesSetting />
        </TabPanel>
      </TabPanels>
    </TabGroup>
  );
}
